
    var riot = require('riot')
    
riot.tag2('bookdelegates', '<button if="{!opts.showqty}" type="button" onclick="{handleAdd}" class="btn btn-block btn-sm {opts.btnClass || \'btn-primary\'}">{delegates && delegates.length > 0 ? \'Update (\'+delegates.length+\')\' : \'Book\'}</button> <modal name="delegatemodal" bssize="lg" title="Book Delegates" closetext="Close" savetext="Save Delegates" backdrop="static" class="delegatemodal"> <form onsubmit="{parent.save}" class="form-horizontal"> <datalist id="nationalities"> <option each="{value in parent.nationalities}" value="{value}"></option> </datalist> <table class="table table-striped"> <thead> <tr> <th>First Name </th> <th>Surname</th> <th>Email Address</th> <th if="{parent.opts.requestnationality}">Nationality</th> <th if="{parent.opts.showcredits}">Use Credits</th> <th>Remove</th> </tr> </thead> <tbody> <tr each="{val,idx in parent.delegates}"> <td> <input name="first_name" value="{val.first_name}" oninput="{parent.parent.updateField}" required class="form-control"> </td> <td> <input name="surname" value="{val.surname}" oninput="{parent.parent.updateField}" required class="form-control"> </td> <td> <input name="email" value="{val.email}" oninput="{parent.parent.updateField}" required class="form-control" type="{\'email\'}"> </td> <td if="{parent.parent.opts.requestnationality}"> <input name="nationality" list="nationalities" value="{val.nationality}" onchange="{parent.parent.updateField}" required class="form-control"> </td> <td if="{parent.parent.opts.showcredits}"> <input name="credits" type="checkbox" __checked="{val.credits}" onchange="{parent.parent.updateField}" class="creditscheck"> </td> <td> <confirm onconfirm="{parent.parent.removeDelegate.bind(this,idx)}" class="btn btn-danger"><span class="fa fa-close"></span></confirm> </td> </tr> </tbody> </table> <div if="{parent.error}" class="alert alert-danger">{parent.error}</div> <div class="alert alert-info"> Please verify that the provided email address belongs to the designated delegate. </div> <div if="{parent.opts.sponsor==\'true\'}" class="alert alert-warning"> <label style="display:flex;gap:10px;align-items: flex-start;"> <input type="checkbox" name="opt_in" __checked="{parent.opt_in}" onchange="{parent.updateOptIn}"> <div>I am happy for NAFEMS to share the contact information I have entered with the event sponsors under the <a href="/about-us/legal/privacy/" target="_blank" style="color: inherit;text-decoration: underline;">NAFEMS Privacy Policy.</a></div> </label> </div> <div if="{+parent.opts.price == 0 &amp;&amp; parent.delegates.length &gt; 0 &amp;&amp; !parent.opts.userid}" class="alert alert-danger">You must be logged in to register for free events.</div> <div style="margin:-15px" class="modal-footer"> <button type="button" onclick="{parent.closeModal}" class="btn btn-default">Close</button> <button type="button" onclick="{parent.addDelegate}" class="btn btn-default">Add Another Delegate</button> <button type="submit" __disabled="{+parent.opts.price == 0 &amp;&amp; !parent.opts.userid}" class="btn btn-primary">{+parent.opts.price==0 ? ⁗Confirm Registration⁗ : ⁗Continue⁗}</button> </div> </form> </modal>', '.delegatemodal .creditscheck { display: block; margin: 10px auto; }', '', function(opts) {
var Formatter, openingLogin, resource, tagSelector;

resource = require('riot-kit/utils/apiResource.coffee');

tagSelector = require('riot-kit/utils/tagSelector.coffee');

Formatter = require('riot-kit/utils/dateformat.coffee');

openingLogin = null;

this.opt_in = false;

this.nationalities = ["Afghan", "Albanian", "Algerian", "American", "Andorran", "Angolan", "Anguillan", "Citizen of Antigua and Barbuda", "Argentine", "Armenian", "Australian", "Austrian", "Azerbaijani", "Bahamian", "Bahraini", "Bangladeshi", "Barbadian", "Belarusian", "Belgian", "Belizean", "Beninese", "Bermudian", "Bhutanese", "Bolivian", "Citizen of Bosnia and Herzegovinaå", "Botswanan", "Brazilian", "British", "British Virgin Islander", "Bruneian", "Bulgarian", "Burkinan", "Burmese", "Burundian", "Cambodian", "Cameroonian", "Canadian", "Cape Verdean", "Cayman Islander", "Central African", "Chadian", "Chilean", "Chinese", "Colombian", "Comoran", "Congolese (Congo)", "Congolese (DRC)", "Cook Islander", "Costa Rican", "Croatian", "Cuban", "Cymraes", "Cymro", "Cypriot", "Czech", "Danish", "Djiboutian", "Dominican", "Citizen of the Dominican Republic", "Dutch", "East Timorese", "Ecuadorean", "Egyptian", "Emirati", "English", "Equatorial Guinean", "Eritrean", "Estonian", "Ethiopian", "Faroese", "Fijian", "Filipino", "Finnish", "French", "Gabonese", "Gambian", "Georgian", "German", "Ghanaian", "Gibraltarian", "Greek", "Greenlandic", "Grenadian", "Guamanian", "Guatemalan", "Citizen of Guinea-Bissau", "Guinean", "Guyanese", "Haitian", "Honduran", "Hong Konger", "Hungarian", "Icelandic", "Indian", "Indonesian", "Iranian", "Iraqi", "Irish", "Israeli", "Italian", "Ivorian", "Jamaican", "Japanese", "Jordanian", "Kazakh", "Kenyan", "Kittitian", "Citizen of Kiribati", "Kosovan", "Kuwaiti", "Kyrgyz", "Lao", "Latvian", "Lebanese", "Liberian", "Libyan", "Liechtenstein citizen", "Lithuanian", "Luxembourger", "Macanese", "Macedonian", "Malagasy", "Malawian", "Malaysian", "Maldivian", "Malian", "Maltese", "Marshallese", "Martiniquais", "Mauritanian", "Mauritian", "Mexican", "Micronesian", "Moldovan", "Monegasque", "Mongolian", "Montenegrin", "Montserratian", "Moroccan", "Mosotho", "Mozambican", "Namibian", "Nauruan", "Nepalese", "New Zealander", "Nicaraguan", "Nigerian", "Nigerien", "Niuean", "North Korean", "Northern Irish", "Norwegian", "Omani", "Pakistani", "Palauan", "Palestinian", "Panamanian", "Papua New Guinean", "Paraguayan", "Peruvian", "Pitcairn Islander", "Polish", "Portuguese", "Prydeinig", "Puerto Rican", "Qatari", "Romanian", "Russian", "Rwandan", "Salvadorean", "Sammarinese", "Samoan", "Sao Tomean", "Saudi Arabian", "Scottish", "Senegalese", "Serbian", "Citizen of Seychelles", "Sierra Leonean", "Singaporean", "Slovak", "Slovenian", "Solomon Islander", "Somali", "South African", "South Korean", "South Sudanese", "Spanish", "Sri Lankan", "St Helenian", "St Lucian", "Stateless", "Sudanese", "Surinamese", "Swazi", "Swedish", "Swiss", "Syrian", "Taiwanese", "Tajik", "Tanzanian", "Thai", "Togolese", "Tongan", "Trinidadian", "Tristanian", "Tunisian", "Turkish", "Turkmen", "Turks and Caicos Islander", "Tuvaluan", "Ugandan", "Ukrainian", "Uruguayan", "Uzbek", "Vatican citizen", "Citizen of Vanuatu", "Venezuelan", "Vietnamese", "Vincentian", "Wallisian", "Welsh", "Yemeni", "Zambian", "Zimbabwean"];

this.on('mount', (function(_this) {
  return function() {
    _this.basket = tagSelector('basket', 'popup-basket');
    _this.basketResource = new resource(opts.src || '/duocms/api/basket');
    _this.delegateResource = new resource('/duocms/api/event_delegates/' + opts.productid, true);
    if (_this.basket) {
      return _this.basket._tag.on("update", _this.basketModalUpdated);
    } else {
      return _this.getDelegates();
    }
  };
})(this));

this.on('unmount', function() {
  if (this.basket) {
    return this.basket._tag.off("update", this.basketModalUpdated);
  }
});

this.on("update", function() {});

this.basketModalUpdated = (function(_this) {
  return function() {
    return _this.getDelegates();
  };
})(this);

this.getDelegates = (function(_this) {
  return function() {
    if (_this.gettingDelegates) {
      return;
    }
    _this.gettingDelegates = true;
    return _this.delegateResource.get(function(delegates) {
      _this.gettingDelegates = false;
      _this.delegates = delegates != null ? delegates : [];
      _this.opt_in = _this.delegates.length > 0 ? _this.delegates[0].opt_in : false;
      return _this.update();
    });
  };
})(this);

this.handleAdd = (function(_this) {
  return function() {
    var loginbar, ref, ref1;
    if (!((ref = _this.delegates) != null ? ref.length : void 0)) {
      _this.delegates = [
        {
          event_id: opts.eventid
        }
      ];
    }
    _this.tags.delegatemodal.show();
    if (+opts.price === 0 && ((ref1 = _this.delegates) != null ? ref1.length : void 0) > 0 && !opts.userid) {
      loginbar = document.querySelector('loginbar');
      if (loginbar && loginbar._tag) {
        if (loginbar._tag.redir) {
          loginbar._tag.redir = null;
        }
        loginbar._tag.tags.loginmodal.show();
        return _this.tags.delegatemodal.hide();
      }
    }
  };
})(this);

this.updateOptIn = (function(_this) {
  return function(e) {
    _this.opt_in = e.target.checked;
    return _this.update();
  };
})(this);

this.updateField = (function(_this) {
  return function(e) {
    if (e.target.type === "checkbox") {
      e.item.val[e.target.name] = e.target.checked;
    } else {
      e.item.val[e.target.name] = e.target.value;
    }
    return _this.update();
  };
})(this);

this.addDelegate = (function(_this) {
  return function() {
    _this.delegates.push({
      event_id: opts.eventid
    });
    return _this.update();
  };
})(this);

this.removeDelegate = (function(_this) {
  return function(idx) {
    _this.delegates.splice(idx, 1);
    return _this.update();
  };
})(this);

this.closeModal = (function(_this) {
  return function(e) {
    _this.delegateResource.get(function(delegates1) {
      _this.delegates = delegates1;
      return _this.update();
    });
    return _this.tags.delegatemodal.hide();
  };
})(this);

this.save = (function(_this) {
  return function(e) {
    var error, invalidEmails;
    if (e) {
      e.preventDefault();
    }
    if (+opts.price === 0 && _this.delegates.length > 0 && !opts.userid) {
      return;
    }
    if (_this.basket) {
      invalidEmails = _this.delegates.map(function(del) {
        return del.email;
      }).filter(function(eml) {
        return !eml.match(/@.+\..*/);
      });
      if (invalidEmails.length) {
        error = "You have " + invalidEmails.length + " invalid emails, " + invalidEmails.join(", ") + ".";
        _this.update({
          error: error
        });
        return;
      }
      if (opts.sponsor === 'true') {
        _this.delegates.forEach(function(del) {
          return del.opt_in = _this.opt_in;
        });
      }
      return _this.delegateResource.post(_this.delegates, function(res, err) {
        if (err) {
          return _this.update({
            error: err.message
          });
        } else {
          _this.update({
            error: false
          });
          return _this.basketResource.save({
            id: opts.productid,
            qty: _this.delegates.length
          }, function() {
            if (+opts.price === 0 && _this.delegates.length > 0) {
              return window.location.href = "/duocms/api/nafems/freeevent_register";
            } else {
              if (window["addToGoogle" + opts.productid]) {
                window["addToGoogle" + opts.productid](_this.delegates.length);
              }
              _this.basket.trigger('updateBasket');
              return _this.tags.delegatemodal.hide();
            }
          });
        }
      });
    }
  };
})(this);
});
    
  